import MainLayout from '../../layouts/mainLayout';
import './style.scss';
import LoginBtn from '../../components/buttons/loginBtn';
import { useLocation, useNavigate } from 'react-router-dom';
import { getPathAcctoYear } from '../../utils/functions/common';

const OTPSent = () => {

  const location = useLocation();

  const navigate = useNavigate()

  const handleClick = async () => {
      navigate(getPathAcctoYear("/login"))
  }


  return (
    <MainLayout>
      <div className='login__section'>
        <h3>
          Email Sent
        </h3>
        <br />
        <p className='welcome__description'>
          Forgot password link sent at {location?.state?.email ?? ''}
        </p>
        <div className='input__section'>
          <LoginBtn onClick={handleClick} text={"Login"} />
        </div>
      </div>
    </MainLayout>
  )
}

export default OTPSent